export default "__VITE_ASSET__Ct1r$P3X__"